import {alpha} from '@material-ui/core/styles';
import {InputBase, withStyles} from '@material-ui/core';

export default withStyles(({palette, transitions}) => ({
  input: {
    borderRadius: 4,
    backgroundColor: palette.common.white,
    border: `1px solid ${palette.action.disabled}`,
    padding: '10px 12px',
    transition: transitions.create(['border-color', 'box-shadow']),
    '&:focus': {boxShadow: `${alpha(palette.action.disabled, 0.25)} 0 0 0 0.2rem`},
  },
  multiline: {
    padding: 0
  }
}))(InputBase);
